var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup23504(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 626,
    height: 336.745,
    viewBox: "0 0 626 336.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23504",
    "data-name": "Group 23504",
    transform: "translate(-828.5 -499.191)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1746",
    "data-name": "Line 1746",
    x2: 615,
    transform: "translate(839.5 795.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Click_here-pana",
    "data-name": "Click here-pana",
    transform: "translate(893.982 392.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-15",
    transform: "translate(45.51 43.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16043",
    "data-name": "Path 16043",
    d: "M444.46,156.54c-12.82,6.638-22.643,18.058-29.707,30.63s-11.619,26.383-16.124,40.076L394.66,297.9c14.883-25.351,26.869-55.158,30.1-84.339l-9.922-.883c6.658-.992,12.244-5.834,15.8-11.549s5.378-12.294,7.164-18.783l-12.046,1.766a44.9,44.9,0,0,0,18.7-27.574Z",
    transform: "translate(-48.225 -44.171)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16044",
    "data-name": "Path 16044",
    d: "M392.209,314.406s-32.366-38.7-31.989-75.667h13.068s-14.2-9.327-13.068-14.556,1.488-25.014,1.488-25.014l11.907,2.977s-8.93-4.475-10.081-11.569,2.61-39.947,2.61-39.947,14.566,15.31,19.051,30.987,16.243,33.974,12.79,81.749S392.209,314.406,392.209,314.406Z",
    transform: "translate(-47.957 -44.125)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16045",
    "data-name": "Path 16045",
    d: "M409,318.4s35.055-23.347,42.844-53.143L441.336,262.4s13.455-4.4,13.7-8.841,4.267-20.44,4.267-20.44l-10.26-.208s8.186-1.647,10.637-7.1,6.648-32.684,6.648-32.684-15.072,9.119-22.107,20.718-20.5,23.813-28.179,62.957S409,318.4,409,318.4Z",
    transform: "translate(-48.337 -44.455)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16046",
    "data-name": "Path 16046",
    d: "M375.15,184.66a2.11,2.11,0,0,1,.109.407l.278,1.191c.238,1.072.585,2.619.992,4.594s.992,4.445,1.528,7.293,1.24,6.082,1.9,9.674c1.379,7.184,2.838,15.766,4.346,25.312s2.907,20.083,4.207,31.156,2.252,21.67,2.977,31.3,1.25,18.326,1.548,25.629c.189,3.651.268,6.946.367,9.863s.149,5.4.169,7.442.05,3.6.06,4.7v1.647a1.784,1.784,0,0,1,0-.417,12.174,12.174,0,0,0-.05-1.23c0-1.1-.089-2.679-.159-4.7s-.139-4.534-.268-7.432-.228-6.211-.437-9.853c-.337-7.3-.913-15.985-1.657-25.609s-1.786-20.212-3.056-31.285-2.729-21.591-4.167-31.146-2.9-18.128-4.227-25.312c-.635-3.6-1.28-6.836-1.826-9.694s-.992-5.3-1.439-7.3-.7-3.532-.923-4.614c-.1-.506-.169-.9-.228-1.2a2.244,2.244,0,0,1-.04-.417Z",
    transform: "translate(-48.074 -44.389)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16047",
    "data-name": "Path 16047",
    d: "M387.41,338.872S357.8,305.3,348.6,284.994l6.946-2.977c-5.04.833-10.19-1.33-14.09-4.614s-6.767-7.571-9.545-11.847l9.138-1.538A33.984,33.984,0,0,1,321.08,248.55c10.785,1.776,20.549,7.7,28.6,15.1C356.185,269.6,361.7,276.61,367,283.714a68.46,68.46,0,0,1,6.737,11.063C378.679,305.057,387.48,326.539,387.41,338.872Z",
    transform: "translate(-47.653 -44.886)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16048",
    "data-name": "Path 16048",
    d: "M452.239,212.82a1.755,1.755,0,0,1-.139.347c-.119.238-.268.566-.456.992-.427.873-1.042,2.123-1.816,3.721s-1.756,3.582-2.858,5.894-2.371,4.911-3.711,7.829c-2.739,5.814-5.874,12.79-9.257,20.589s-6.946,16.441-10.458,25.58-6.707,17.929-9.476,25.966-5.12,15.31-7.005,21.452c-.992,3.056-1.786,5.854-2.53,8.295s-1.359,4.554-1.855,6.281-.893,3.036-1.161,3.969l-.318.992a2.448,2.448,0,0,1-.129.347,1.857,1.857,0,0,1,.079-.367q.089-.387.268-1.042c.248-.943.605-2.282,1.072-3.969s1.052-3.85,1.766-6.3,1.5-5.259,2.451-8.325c1.846-6.152,4.187-13.445,6.946-21.5s5.953-16.868,9.446-26,7.134-17.781,10.508-25.58,6.588-14.754,9.367-20.549c1.359-2.917,2.659-5.517,3.78-7.809s2.113-4.257,2.977-5.854l1.9-3.681q.327-.6.506-.992a2.815,2.815,0,0,1,.109-.288Z",
    transform: "translate(-48.275 -44.608)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16049",
    "data-name": "Path 16049",
    d: "M390.289,353.64a4.363,4.363,0,0,1-.129-.625c-.07-.456-.169-1.052-.278-1.776s-.258-1.726-.456-2.818-.387-2.352-.685-3.721c-.526-2.748-1.29-6-2.252-9.575s-2.233-7.442-3.731-11.44-3.165-7.72-4.773-11.053-3.215-6.261-4.634-8.672c-.685-1.22-1.369-2.282-1.984-3.235s-1.091-1.766-1.528-2.421l-.992-1.518a2.539,2.539,0,0,1-.308-.556,3.287,3.287,0,0,1,.4.5l1.042,1.468c.456.635.992,1.429,1.6,2.371s1.31,1.984,1.984,3.2c1.469,2.4,3.086,5.328,4.753,8.652s3.3,7.075,4.832,11.083,2.719,7.938,3.7,11.5,1.667,6.856,2.153,9.625c.278,1.379.437,2.639.605,3.741s.3,2.054.377,2.838.139,1.33.179,1.8a2.557,2.557,0,0,1,.129.635Z",
    transform: "translate(-48.022 -45.257)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8824",
    "data-name": "Rectangle 8824",
    width: 64.812,
    height: 13.216,
    transform: "translate(316.529 300.485)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16050",
    "data-name": "Path 16050",
    d: "M370.75,359.44l7.005,44.452h39.163l6.539-44.452Z",
    transform: "translate(-48.039 -45.749)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16051",
    "data-name": "Path 16051",
    d: "M425.411,359.438c0,.149-12.264.258-27.385.258s-27.385-.109-27.385-.258,12.264-.258,27.385-.258S425.411,359.3,425.411,359.438Z",
    transform: "translate(-48.039 -45.747)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16062",
    "data-name": "Path 16062",
    d: "M85.68,274.4,53.82,403.22H62.2L94.848,274.4Z",
    transform: "translate(-45.575 -45.087)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16063",
    "data-name": "Path 16063",
    d: "M146.338,274.4l29.806,128.82H167.76L137.16,274.4Z",
    transform: "translate(-46.223 -45.087)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16064",
    "data-name": "Path 16064",
    d: "M121.222,401.161h-9.763L110,253.31h9.763Z",
    transform: "translate(-46.012 -44.923)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8825",
    "data-name": "Rectangle 8825",
    width: 137.75,
    height: 88.248,
    transform: "translate(0 121.557)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8826",
    "data-name": "Rectangle 8826",
    width: 69.138,
    height: 8.523,
    transform: "translate(34.341 227.963)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16065",
    "data-name": "Path 16065",
    d: "M54.727,242.583a8.414,8.414,0,0,1,.1,1.617h-.189c-.139-4.316-.248-18.614-.248-35.561,0-10.22.079-19.477.1-26.284,0-3.294.079-5.953.109-7.938,0-.883,0-1.6.06-2.173a4.088,4.088,0,0,1,.069-.754,2.649,2.649,0,0,1,.069.754c0,.575,0,1.29.069,2.173,0,1.984.06,4.673.109,7.938,0,6.807.06,16.064.1,26.284,0,16.947-.109,31.245-.248,35.561h-.189a10.686,10.686,0,0,1,.089-1.617Z",
    transform: "translate(-45.579 -44.287)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16066",
    "data-name": "Path 16066",
    d: "M65.068,242.583a10.686,10.686,0,0,1,.089,1.617H65c-.139-4.316-.248-18.614-.248-35.561,0-10.22.079-19.477.1-26.284.05-3.294.089-5.953.109-7.938a19.676,19.676,0,0,1,.069-2.173,2.649,2.649,0,0,1,.069-.754,3.721,3.721,0,0,1,.06.754c0,.575,0,1.29.069,2.173,0,1.984.06,4.673.109,7.938,0,6.807.06,16.064.1,26.284,0,16.947-.109,31.245-.248,35.561H65a8.414,8.414,0,0,1,.069-1.617Z",
    transform: "translate(-45.66 -44.287)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16067",
    "data-name": "Path 16067",
    d: "M75.4,242.583a10.687,10.687,0,0,1,.089,1.617H75.3c-.139-4.316-.238-18.614-.238-35.561,0-10.22.069-19.477.1-26.284,0-3.294.079-5.953.109-7.938,0-.883,0-1.6.06-2.173a3.2,3.2,0,0,1,.069-.754,3.206,3.206,0,0,1,.069.754c0,.575,0,1.29.06,2.173,0,1.984.069,4.673.109,7.938,0,6.807.06,16.064.1,26.284,0,16.947-.1,31.245-.248,35.561H75.3a9.633,9.633,0,0,1,.1-1.617Z",
    transform: "translate(-45.74 -44.287)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16068",
    "data-name": "Path 16068",
    d: "M85.727,242.583a9.635,9.635,0,0,1,.1,1.617h-.189c-.149-4.316-.248-18.614-.248-35.561,0-10.22.069-19.477.1-26.284,0-3.294.079-5.953.109-7.938,0-.883.05-1.6.06-2.173a3.2,3.2,0,0,1,.069-.754,3.206,3.206,0,0,1,.069.754c0,.575,0,1.29.06,2.173,0,1.984.069,4.673.109,7.938,0,6.807.06,16.064.1,26.284,0,16.947-.1,31.245-.238,35.561h-.189a10.687,10.687,0,0,1,.089-1.617Z",
    transform: "translate(-45.82 -44.287)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16069",
    "data-name": "Path 16069",
    d: "M96.058,242.583a8.414,8.414,0,0,1,.1,1.617H96c-.139-4.316-.248-18.614-.248-35.561,0-10.22.079-19.477.1-26.284.05-3.294.079-5.953.109-7.938,0-.883,0-1.6.06-2.173a4.088,4.088,0,0,1,.069-.754,2.65,2.65,0,0,1,.069.754c0,.575,0,1.29.069,2.173,0,1.984.06,4.673.109,7.938,0,6.807.06,16.064.1,26.284,0,16.947-.109,31.245-.248,35.561H96a10.684,10.684,0,0,1,.06-1.617Z",
    transform: "translate(-45.901 -44.287)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16070",
    "data-name": "Path 16070",
    d: "M106.4,242.583a10.684,10.684,0,0,1,.089,1.617H106.3c-.139-4.316-.248-18.614-.248-35.561,0-10.22.079-19.477.1-26.284,0-3.294.089-5.953.109-7.938a19.676,19.676,0,0,1,.069-2.173,2.649,2.649,0,0,1,.069-.754,3.719,3.719,0,0,1,.06.754c0,.575,0,1.29.069,2.173,0,1.984.06,4.673.109,7.938,0,6.807.06,16.064.1,26.284,0,16.947-.109,31.245-.248,35.561H106.3a8.415,8.415,0,0,1,.1-1.617Z",
    transform: "translate(-45.981 -44.287)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16071",
    "data-name": "Path 16071",
    d: "M116.727,242.583a10.686,10.686,0,0,1,.089,1.617h-.189c-.139-4.316-.238-18.614-.238-35.561,0-10.22.069-19.477.1-26.284,0-3.294.079-5.953.109-7.938,0-.883,0-1.6.06-2.173a3.2,3.2,0,0,1,.069-.754,3.2,3.2,0,0,1,.069.754c0,.575,0,1.29.06,2.173,0,1.984.069,4.673.109,7.938,0,6.807.06,16.064.1,26.284,0,16.947-.1,31.245-.248,35.561h-.189a9.636,9.636,0,0,1,.1-1.617Z",
    transform: "translate(-46.061 -44.287)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16072",
    "data-name": "Path 16072",
    d: "M127.058,242.583a9.634,9.634,0,0,1,.1,1.617H127c-.149-4.316-.248-18.614-.248-35.561,0-10.22.069-19.477.1-26.284,0-3.294.079-5.953.109-7.938,0-.883,0-1.6.06-2.173a3.205,3.205,0,0,1,.069-.754,3.205,3.205,0,0,1,.069.754c0,.575,0,1.29.06,2.173,0,1.984.069,4.673.109,7.938,0,6.807.06,16.064.1,26.284,0,16.947-.1,31.245-.238,35.561H127a10.686,10.686,0,0,1,.06-1.617Z",
    transform: "translate(-46.142 -44.287)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16073",
    "data-name": "Path 16073",
    d: "M137.387,242.583a8.414,8.414,0,0,1,.1,1.617H137.3c-.139-4.316-.248-18.614-.248-35.561,0-10.22.079-19.477.1-26.284,0-3.294.079-5.953.109-7.938,0-.883.05-1.6.06-2.173a4.089,4.089,0,0,1,.069-.754,2.65,2.65,0,0,1,.069.754c0,.575,0,1.29.069,2.173,0,1.984.06,4.673.109,7.938,0,6.807.06,16.064.1,26.284,0,16.947-.109,31.245-.248,35.561H137.3A10.686,10.686,0,0,1,137.387,242.583Z",
    transform: "translate(-46.222 -44.287)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16074",
    "data-name": "Path 16074",
    d: "M147.727,242.583a10.686,10.686,0,0,1,.089,1.617h-.189c-.139-4.316-.248-18.614-.248-35.561,0-10.22.079-19.477.1-26.284.05-3.294.089-5.953.109-7.938a19.676,19.676,0,0,1,.069-2.173,2.65,2.65,0,0,1,.069-.754,4.087,4.087,0,0,1,.069.754c0,.575,0,1.29.06,2.173,0,1.984.06,4.673.109,7.938,0,6.807.06,16.064.1,26.284,0,16.947-.109,31.245-.248,35.561h-.189A8.414,8.414,0,0,1,147.727,242.583Z",
    transform: "translate(-46.302 -44.287)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16075",
    "data-name": "Path 16075",
    d: "M158.058,242.583a10.684,10.684,0,0,1,.089,1.617H158c-.139-4.316-.238-18.614-.238-35.561,0-10.22.069-19.477.1-26.284,0-3.294.079-5.953.109-7.938,0-.883,0-1.6.06-2.173a3.2,3.2,0,0,1,.069-.754,3.2,3.2,0,0,1,.069.754c0,.575,0,1.29.06,2.173,0,1.984.069,4.673.109,7.938,0,6.807.06,16.064.1,26.284,0,16.947-.1,31.245-.248,35.561H158a9.635,9.635,0,0,1,.06-1.617Z",
    transform: "translate(-46.383 -44.287)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16076",
    "data-name": "Path 16076",
    d: "M168.387,242.583a9.634,9.634,0,0,1,.1,1.617H168.3c-.149-4.316-.248-18.614-.248-35.561,0-10.22.069-19.477.1-26.284,0-3.294.079-5.953.109-7.938,0-.883.05-1.6.06-2.173a3.207,3.207,0,0,1,.069-.754,3.206,3.206,0,0,1,.069.754c0,.575,0,1.29.06,2.173,0,1.984.069,4.673.109,7.938,0,6.807.06,16.064.1,26.284,0,16.947-.1,31.245-.238,35.561H168.3A10.69,10.69,0,0,1,168.387,242.583Z",
    transform: "translate(-46.463 -44.287)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16077",
    "data-name": "Path 16077",
    d: "M178.717,242.583a8.413,8.413,0,0,1,.1,1.617h-.189c-.139-4.316-.248-18.614-.248-35.561,0-10.22.079-19.477.1-26.284.05-3.294.079-5.953.109-7.938,0-.883,0-1.6.06-2.173a4.088,4.088,0,0,1,.069-.754,2.649,2.649,0,0,1,.069.754c0,.575,0,1.29.069,2.173,0,1.984.06,4.673.109,7.938,0,6.807.06,16.064.1,26.284,0,16.947-.109,31.245-.248,35.561h-.189a10.688,10.688,0,0,1,.089-1.617Z",
    transform: "translate(-46.543 -44.287)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-15",
    transform: "translate(137.862 147.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16078",
    "data-name": "Path 16078",
    d: "M262.568,90.209l-5.277,47.545c-.9,8.088-3.875,19.779-16.589,17.781h0c-10.906-2.574-12.545-13.4-11.7-20.944.4-3.577.725-6.564.745-6.93,0,0-11.976-2.486-11.515-14.564.224-5.832,1.653-17.822,3.075-28.646A22.5,22.5,0,0,1,244.76,64.916l1.165.054C258.443,66.318,264.275,77.732,262.568,90.209Z",
    transform: "translate(-137.345 -54.72)",
    fill: "#936760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16079",
    "data-name": "Path 16079",
    d: "M235.092,155.721a29.181,29.181,0,0,0,15.945-3.861s-4.274,8.623-16.257,6.93Z",
    transform: "translate(-142.687 -82.78)",
    fill: "#6f4c47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16080",
    "data-name": "Path 16080",
    d: "M251.994,103.922c.21.271,1.727-.677,3.732-.474s3.387,1.355,3.624,1.131c.122-.108-.074-.576-.677-1.118a5.067,5.067,0,0,0-2.872-1.213,4.877,4.877,0,0,0-3,.677C252.17,103.366,251.919,103.8,251.994,103.922Z",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, -112.759, -129.418)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16081",
    "data-name": "Path 16081",
    d: "M251.369,110.186a1.639,1.639,0,0,0,1.49,1.727,1.565,1.565,0,0,0,1.754-1.389,1.632,1.632,0,0,0-1.49-1.721,1.565,1.565,0,0,0-1.754,1.382Z",
    transform: "translate(-148.038 -71.079)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16082",
    "data-name": "Path 16082",
    d: "M239.883,117.065a11.642,11.642,0,0,0-2.98-.677c-.474-.075-.914-.19-.982-.515a2.4,2.4,0,0,1,.386-1.355l1.585-3.536c2.2-5.04,3.82-9.192,3.617-9.273s-2.154,3.922-4.355,8.962q-.806,1.856-1.524,3.556a2.71,2.71,0,0,0-.339,1.849,1.172,1.172,0,0,0,.745.732,2.919,2.919,0,0,0,.8.149A13.834,13.834,0,0,0,239.883,117.065Z",
    transform: "translate(-142.839 -66.6)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16083",
    "data-name": "Path 16083",
    d: "M254.668,93.238c.142.467,1.781.332,3.692.677s3.434.955,3.705.555c.129-.2-.122-.677-.725-1.118a6.1,6.1,0,0,0-2.71-1.138,5.934,5.934,0,0,0-2.919.21C254.986,92.676,254.613,93.015,254.668,93.238Z",
    transform: "translate(-149.102 -63.507)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16084",
    "data-name": "Path 16084",
    d: "M226.876,93.233c.169.386,1.781.176,3.678.352s3.448.616,3.692.257c.108-.169-.163-.528-.786-.9a6.692,6.692,0,0,0-2.709-.806,6.916,6.916,0,0,0-2.872.339C227.154,92.711,226.808,93.043,226.876,93.233Z",
    transform: "translate(-140.135 -63.502)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16085",
    "data-name": "Path 16085",
    d: "M281.063,115.267c.21-.081,8.42-2.032,7.742,6.2S280,127.324,280,127.087,281.063,115.267,281.063,115.267Z",
    transform: "translate(-157.277 -70.891)",
    fill: "#936760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16086",
    "data-name": "Path 16086",
    d: "M284.086,125.493c.041,0,.135.115.373.244a1.422,1.422,0,0,0,1.07.108c.894-.244,1.741-1.565,1.9-3.048a4.742,4.742,0,0,0-.23-2.086,1.666,1.666,0,0,0-.989-1.192.738.738,0,0,0-.881.325c-.129.217-.088.386-.135.4s-.163-.156-.068-.488a.887.887,0,0,1,.366-.488,1.077,1.077,0,0,1,.806-.149,2.032,2.032,0,0,1,1.4,1.4,4.81,4.81,0,0,1,.312,2.337c-.19,1.66-1.165,3.143-2.384,3.387a1.558,1.558,0,0,1-1.3-.325C284.086,125.7,284.059,125.507,284.086,125.493Z",
    transform: "translate(-158.592 -72.209)",
    fill: "#6f4c47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16087",
    "data-name": "Path 16087",
    d: "M243.909,130.847c-.061-.217,1.605-.5,2.919-1.87a9.322,9.322,0,0,0,1.4-2c.312-.569.542-.921.63-.881s0,.44-.2,1.07a6.042,6.042,0,0,1-1.355,2.262,4.9,4.9,0,0,1-2.29,1.355C244.35,130.955,243.923,130.921,243.909,130.847Z",
    transform: "translate(-145.632 -74.467)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16088",
    "data-name": "Path 16088",
    d: "M225.991,100.092c.21.271,1.727-.677,3.732-.474s3.387,1.355,3.624,1.124c.122-.1-.075-.569-.677-1.111a5.019,5.019,0,0,0-2.872-1.212,4.877,4.877,0,0,0-3,.677C226.147,99.536,225.9,99.97,225.991,100.092Z",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, -106.245, -121.582)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16089",
    "data-name": "Path 16089",
    d: "M225.8,107.041a1.639,1.639,0,0,0,1.49,1.727,1.565,1.565,0,0,0,1.754-1.355,1.619,1.619,0,0,0-1.483-1.721,1.558,1.558,0,0,0-1.761,1.348Z",
    transform: "translate(-139.789 -70.518)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16090",
    "data-name": "Path 16090",
    d: "M267.047,86.884c-.6,2.3-2.032,7.532-4.064,7.065-4.064-.921-3.827,5.6-5.792,4.83s-2.425-5.947-2.2-8.013c.677-6.455,3.157-11.089.427-18.458a9.822,9.822,0,0,0-8.311-4.9,9.991,9.991,0,0,0-8.494,4.742c-.42-2.256-1.6-5.643-3.638-6.686a5.853,5.853,0,0,0-6.435.677,4.742,4.742,0,0,0-.677,6.212,2.283,2.283,0,0,1-2.567-.86,3.881,3.881,0,0,0,1.077,2.892,3.563,3.563,0,0,1-2.086-1.355l.677,2.791c-3.387.169-6.835-3.055-7.851-5.974-1.538-4.43-.535-8.955,1.863-12.978a14.018,14.018,0,0,1,11.515-6.99c4.742-.068,8.664,2.066,10.567,6.347,2.994-2.222,9.138-3.109,12.559-1.646a10.953,10.953,0,0,1,6.435,8.521,6.54,6.54,0,0,1,6.482,1.1l.44.366a9.74,9.74,0,0,1,3.035,8.921c-.217,1.3-.637,2.655-.874,3.705C268.334,80.307,267.047,86.884,267.047,86.884Z",
    transform: "translate(-136.75 -49.878)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16091",
    "data-name": "Path 16091",
    d: "M227.517,75.844a1.851,1.851,0,0,1-.278-.21,4.743,4.743,0,0,1-.677-.718,6.774,6.774,0,0,1-1.416-3.387,6.469,6.469,0,0,1,1.47-5.148,6.99,6.99,0,0,1,6.042-2.439,7.736,7.736,0,0,1,3.258,1.192,10.432,10.432,0,0,1,2.432,2.12A12.667,12.667,0,0,1,240.9,72a12.451,12.451,0,0,1,.481,3.624,6.462,6.462,0,0,1-.075.989,1.429,1.429,0,0,1-.061.339,15.112,15.112,0,0,0-.583-4.884,12.761,12.761,0,0,0-2.567-4.633,8.955,8.955,0,0,0-5.48-3.177,6.733,6.733,0,0,0-5.751,2.3,6.266,6.266,0,0,0-1.47,4.9,6.95,6.95,0,0,0,1.26,3.346C227.165,75.519,227.537,75.817,227.517,75.844Z",
    transform: "translate(-139.556 -54.404)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16092",
    "data-name": "Path 16092",
    d: "M224.813,78.321a1.944,1.944,0,0,1-.251-.379c-.156-.257-.379-.677-.677-1.138a24.76,24.76,0,0,1-1.978-4.4,12.707,12.707,0,0,1-.6-3.3,9.314,9.314,0,0,1,.6-3.807,7.356,7.356,0,0,1,2.662-3.319,8.914,8.914,0,0,1,4.3-1.531,10.838,10.838,0,0,1,4.525.616,14.17,14.17,0,0,1,3.746,2.032,11.028,11.028,0,0,1,4.173,5.751,8.047,8.047,0,0,1-.129,4.8,6.515,6.515,0,0,1-.569,1.185,2.709,2.709,0,0,1-.271.373,10.574,10.574,0,0,0,.677-1.605,8.067,8.067,0,0,0,0-4.687,10.885,10.885,0,0,0-4.125-5.561,12.193,12.193,0,0,0-7.966-2.54,8.691,8.691,0,0,0-4.139,1.47,7.079,7.079,0,0,0-2.554,3.157,9.09,9.09,0,0,0-.616,3.671,12.722,12.722,0,0,0,.549,3.238,27.331,27.331,0,0,0,1.863,4.41l.589,1.172A2.418,2.418,0,0,1,224.813,78.321Z",
    transform: "translate(-138.336 -53.277)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16093",
    "data-name": "Path 16093",
    d: "M286.849,89.807c-.041-.054.725-.616,1.666-1.8a11.691,11.691,0,0,0,2.032-11.041c-.467-1.436-.982-2.235-.921-2.262s.163.169.386.542a9.76,9.76,0,0,1,.772,1.639,11.265,11.265,0,0,1-2.073,11.285,10.161,10.161,0,0,1-1.3,1.26A2.345,2.345,0,0,1,286.849,89.807Z",
    transform: "translate(-159.486 -57.888)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16094",
    "data-name": "Path 16094",
    d: "M276.12,90.593c0-.034.393-.19,1.016-.637a5.791,5.791,0,0,0,1.958-2.466l.312-.772-.054.833c-.074,1.124-.163,2.418-.251,3.827l-.264-.149a10.5,10.5,0,0,0,4.234-6.855,10.8,10.8,0,0,0-.108-3.753,14.794,14.794,0,0,0-1.206-3.272,1.063,1.063,0,0,1,.156.2,6.467,6.467,0,0,1,.366.6,9.794,9.794,0,0,1,.921,2.425A10.438,10.438,0,0,1,279.026,91.5l-.291.2v-.352l.318-3.82.264.061a5.7,5.7,0,0,1-2.12,2.493,4.8,4.8,0,0,1-.8.413A1.233,1.233,0,0,1,276.12,90.593Z",
    transform: "translate(-156.025 -58.741)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16095",
    "data-name": "Path 16095",
    d: "M265.476,70.285a7.676,7.676,0,0,0-1.9-2.256,6.727,6.727,0,0,0-2.9-1.246,7.14,7.14,0,0,0-3.834.434,8.258,8.258,0,0,0-3.163,2.249,9.768,9.768,0,0,0-1.666,2.709,19.424,19.424,0,0,0-.806,2.879,2.751,2.751,0,0,1,.041-.813,9.9,9.9,0,0,1,.528-2.154,9.733,9.733,0,0,1,1.66-2.859,8.413,8.413,0,0,1,3.279-2.364,7.356,7.356,0,0,1,4.024-.427,6.774,6.774,0,0,1,2.994,1.4,5.928,5.928,0,0,1,1.436,1.7,4.937,4.937,0,0,1,.257.549.59.59,0,0,1,.054.2Z",
    transform: "translate(-147.982 -55.185)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16096",
    "data-name": "Path 16096",
    d: "M263.426,62.673a11.752,11.752,0,0,0-2.249-.8,7.993,7.993,0,0,0-5.419.9,9.991,9.991,0,0,0-3.787,4.125c-.677,1.3-.86,2.2-.921,2.181a1.89,1.89,0,0,1,.1-.637,10.025,10.025,0,0,1,.6-1.66,9.612,9.612,0,0,1,3.82-4.281,7.871,7.871,0,0,1,5.69-.84,6.1,6.1,0,0,1,1.646.677,2.182,2.182,0,0,1,.522.332Z",
    transform: "translate(-147.936 -53.615)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16097",
    "data-name": "Path 16097",
    d: "M193.8,336.371l75.69,1.03s21.168-8.86,26.987-9.1,17.361.5,22.7,9.1c5.521,8.887,6.293,24.562-10.716,35.948-16.569,11.1-92.319,21.344-102.7,20.4l-19.129-25.7s-.2-21.06,0-22.062,3.387-10.025,3.387-10.025Z",
    transform: "translate(-127.124 -139.694)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16098",
    "data-name": "Path 16098",
    d: "M259.94,392.71l39.227,14.57-17.876,48.886c-4.565-1.991-4.694-30.712-4.694-30.712l-25.517-8.3Z",
    transform: "translate(-147.946 -160.484)",
    fill: "#0090ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23500",
    "data-name": "Group 23500",
    transform: "translate(131.712 248.232)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16099",
    "data-name": "Path 16099",
    d: "M293.615,417.187a2.127,2.127,0,0,1,2.784-.549,2.032,2.032,0,0,1,.569,2.75,2.242,2.242,0,0,1-2.953.569,2.124,2.124,0,0,1-.271-2.933",
    transform: "translate(-293.27 -416.34)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16100",
    "data-name": "Path 16100",
    d: "M312.711,413.5l-3.963-1.5L293.06,459.552s.149,2.527,1.775,2.838Z",
    transform: "translate(-161.49 -166.708)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16101",
    "data-name": "Path 16101",
    d: "M287.957,440.386c.244.081.786-1.07,1.985-1.964s2.432-1.152,2.418-1.409-1.524-.4-2.953.677S287.686,440.332,287.957,440.386Z",
    transform: "translate(-159.814 -174.719)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16102",
    "data-name": "Path 16102",
    d: "M288.3,449.725c.21.135.989-.745,2.3-1.185s2.459-.291,2.54-.528-1.219-.887-2.831-.312S288.083,449.637,288.3,449.725Z",
    transform: "translate(-159.941 -178.151)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16103",
    "data-name": "Path 16103",
    d: "M293.52,458.006c.135-.2-.942-.969-2.472-.833s-2.459,1.064-2.3,1.24,1.111-.264,2.371-.359S293.412,458.236,293.52,458.006Z",
    transform: "translate(-160.094 -181.277)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16104",
    "data-name": "Path 16104",
    d: "M279.543,435.96c.251,0,.325-1.24.908-2.554s1.4-2.215,1.24-2.411-1.355.5-2.032,2.032S279.313,436.007,279.543,435.96Z",
    transform: "translate(-157.036 -172.826)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16105",
    "data-name": "Path 16105",
    d: "M270.821,429.424a4.922,4.922,0,0,0,.887-2.452,12.1,12.1,0,0,0,.149-2.852,13.85,13.85,0,0,0-.23-1.68,3.386,3.386,0,0,0-.312-.948,1.1,1.1,0,0,0-1.226-.576,1.389,1.389,0,0,0-.928.847,3.59,3.59,0,0,0-.21.962,9.143,9.143,0,0,0-.034,1.714,9.035,9.035,0,0,0,.677,2.8c.637,1.517,1.355,2.229,1.463,2.168s-.434-.908-.874-2.378a10.283,10.283,0,0,1-.434-2.635,9.488,9.488,0,0,1,.081-1.565c.054-.569.21-1.009.488-1.057.108,0,.142,0,.257.156a2.913,2.913,0,0,1,.224.677,13.625,13.625,0,0,1,.264,1.558,14.66,14.66,0,0,1,.041,2.71A25.148,25.148,0,0,0,270.821,429.424Z",
    transform: "translate(-153.693 -169.576)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16106",
    "data-name": "Path 16106",
    d: "M268.362,432.163c.068-.068-.616-.853-2.134-1.511a8.426,8.426,0,0,0-2.8-.677,8.807,8.807,0,0,0-1.721.081,2.147,2.147,0,0,0-1.8,1.111,1.206,1.206,0,0,0,.3,1.267,3.483,3.483,0,0,0,.806.583,5.744,5.744,0,0,0,1.653.6,5.86,5.86,0,0,0,2.906-.122c1.619-.488,2.269-1.355,2.195-1.429a13.277,13.277,0,0,1-2.337.826,6.1,6.1,0,0,1-2.588-.068,5.682,5.682,0,0,1-1.4-.562c-.495-.271-.84-.616-.718-.793a1.874,1.874,0,0,1,1.118-.562,8.723,8.723,0,0,1,1.544-.122,9.694,9.694,0,0,1,2.621.42C267.474,431.7,268.274,432.284,268.362,432.163Z",
    transform: "translate(-150.773 -172.503)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16107",
    "data-name": "Path 16107",
    d: "M198.333,383.79,160.4,401.4l21.676,47.335c4.389-2.344,2.262-30.99,2.262-30.99l24.785-10.283Z",
    transform: "translate(-118.69 -157.607)",
    fill: "#0090ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23501",
    "data-name": "Group 23501",
    transform: "translate(57.401 243.841)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16108",
    "data-name": "Path 16108",
    d: "M187.131,410.578a2.127,2.127,0,0,0-2.818-.332,2.032,2.032,0,0,0-.345,2.791,2.238,2.238,0,0,0,2.98.332,2.115,2.115,0,0,0,.041-2.94",
    transform: "translate(-183.564 -409.858)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16109",
    "data-name": "Path 16109",
    d: "M160.37,408.935l3.827-1.775,19.38,46.143s.047,2.527-1.544,2.967Z",
    transform: "translate(-118.681 -165.146)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16110",
    "data-name": "Path 16110",
    d: "M194.354,433.329c-.237.1-.874-1.009-2.134-1.809s-2.513-.955-2.52-1.213,1.49-.522,3,.474S194.584,433.281,194.354,433.329Z",
    transform: "translate(-128.143 -172.538)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16111",
    "data-name": "Path 16111",
    d: "M194.526,442.646c-.2.156-1.05-.677-2.391-1s-2.472-.095-2.567-.325,1.145-.982,2.8-.535S194.743,442.538,194.526,442.646Z",
    transform: "translate(-128.099 -175.949)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16112",
    "data-name": "Path 16112",
    d: "M189.994,451.29c-.142-.19.86-1.043,2.4-1.03s2.54.867,2.391,1.057-1.131-.176-2.391-.169S190.136,451.506,189.994,451.29Z",
    transform: "translate(-128.234 -179.051)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16113",
    "data-name": "Path 16113",
    d: "M203.309,428.2c-.257,0-.42-1.213-1.111-2.472s-1.565-2.1-1.416-2.31,1.409.393,2.2,1.9S203.539,428.23,203.309,428.2Z",
    transform: "translate(-131.713 -170.379)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16114",
    "data-name": "Path 16114",
    d: "M211.36,420.923a4.662,4.662,0,0,1-1.07-2.378,11.6,11.6,0,0,1-.379-2.831,13.311,13.311,0,0,1,.1-1.687,3.143,3.143,0,0,1,.23-.975,1.1,1.1,0,0,1,1.179-.677,1.355,1.355,0,0,1,1,.765,3.522,3.522,0,0,1,.264,1.009,9.4,9.4,0,0,1,.169,1.707,9.293,9.293,0,0,1-.434,2.838c-.515,1.565-1.206,2.337-1.287,2.276s.352-.935.677-2.439a10.248,10.248,0,0,0,.224-2.655,9.192,9.192,0,0,0-.2-1.558c-.095-.555-.284-.989-.569-1.016-.108,0-.142,0-.244.176a2.771,2.771,0,0,0-.163.677,13.114,13.114,0,0,0-.142,1.578,14.18,14.18,0,0,0,.169,2.71A17.659,17.659,0,0,1,211.36,420.923Z",
    transform: "translate(-134.664 -166.825)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16115",
    "data-name": "Path 16115",
    d: "M211.357,423.577c-.075-.068.542-.908,2-1.673a8.406,8.406,0,0,1,4.464-.914,2.154,2.154,0,0,1,1.89.962,1.226,1.226,0,0,1-.21,1.294,3.557,3.557,0,0,1-.759.643,5.833,5.833,0,0,1-1.6.732,5.961,5.961,0,0,1-2.906.108c-1.653-.366-2.371-1.2-2.3-1.26a12.325,12.325,0,0,0,2.4.677,6.042,6.042,0,0,0,2.574-.271,5.329,5.329,0,0,0,1.355-.677c.467-.3.792-.677.677-.84a1.47,1.47,0,0,0-1.152-.474,7.976,7.976,0,0,0-1.558,0,9.314,9.314,0,0,0-2.574.623C212.2,423.022,211.445,423.7,211.357,423.577Z",
    transform: "translate(-135.129 -169.601)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16116",
    "data-name": "Path 16116",
    d: "M161.736,334.509s-32.69-12.193-44.707-10.635c-6.726.887-17.246,6.022-18.052,14.645s1.307,20.159,12.938,25.774,58.058,26.451,69.092,29.655,38.509,10.723,38.509,10.723l10.445-29.8s-57-19.739-60.009-21.947-10.628-5.209-10.628-5.209Z",
    transform: "translate(-98.825 -138.232)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16117",
    "data-name": "Path 16117",
    d: "M318.258,344.638l-.23-.054-.677-.2c-.576-.169-1.429-.42-2.54-.677a27.692,27.692,0,0,0-9.6-.711,32.45,32.45,0,0,0-6.543,1.246,23.1,23.1,0,0,0-3.448,1.355l-3.556,1.741c-4.891,2.337-10.357,4.742-16.169,7.024-11.651,4.667-22.834,6.882-30.807,8.7-4,.881-7.234,1.612-9.483,2.141l-2.567.61-.677.149-.23.041a.677.677,0,0,1,.217-.075l.677-.183c.583-.156,1.436-.4,2.554-.677,2.215-.569,5.419-1.355,9.436-2.249,7.966-1.876,19.115-4.125,30.726-8.806,5.812-2.3,11.272-4.674,16.162-7l3.563-1.721a23.234,23.234,0,0,1,3.5-1.355,31.519,31.519,0,0,1,6.6-1.212,27.1,27.1,0,0,1,9.693.826c1.111.284,1.958.555,2.533.752l.643.237Z",
    transform: "translate(-141.703 -144.317)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16118",
    "data-name": "Path 16118",
    d: "M348.526,338.836c0,.061-1-.122-2.594-.291a38.975,38.975,0,0,0-12.5.643c-1.578.332-2.54.61-2.554.555a2.885,2.885,0,0,1,.677-.264c.427-.149,1.057-.339,1.842-.535a32.515,32.515,0,0,1,6.266-.935,33.25,33.25,0,0,1,6.32.285c.806.122,1.45.244,1.89.345a3.2,3.2,0,0,1,.65.2Z",
    transform: "translate(-173.692 -142.823)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16119",
    "data-name": "Path 16119",
    d: "M162.379,349.2c-.034.047-.942-.677-2.506-1.619a33.042,33.042,0,0,0-13.459-4.742c-1.829-.23-2.974-.251-2.974-.312a3.388,3.388,0,0,1,.806-.047,17.851,17.851,0,0,1,2.195.108,29.621,29.621,0,0,1,13.547,4.789,20.445,20.445,0,0,1,1.775,1.294,3.067,3.067,0,0,1,.616.528Z",
    transform: "translate(-113.219 -144.276)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16120",
    "data-name": "Path 16120",
    d: "M177.934,389.228l.257.095.738.312c.677.271,1.612.718,2.892,1.212,2.547,1.009,6.306,2.391,11.136,3.983,9.653,3.15,23.532,7.173,40.141,11.353l-.183.1,10.106-28.05.095.224L230.6,373.317l-69.248-28.524h0c-2.818-2.98-5.419-5.609-7.844-7.736a53.163,53.163,0,0,0-6.577-4.952,48.316,48.316,0,0,0-4.511-2.513l-1.212-.569-.406-.2.42.176,1.226.535A44.034,44.034,0,0,1,147,332a51.9,51.9,0,0,1,6.631,4.924c2.452,2.113,5.06,4.742,7.891,7.709h-.041l69.255,28.341,12.518,5.141.149.061-.054.163-10.161,28.036-.047.135-.142-.034c-16.609-4.213-30.482-8.278-40.128-11.515-4.823-1.612-8.576-3.028-11.116-4.064-1.273-.5-2.222-.969-2.872-1.253l-.732-.332Z",
    transform: "translate(-112.367 -139.872)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16121",
    "data-name": "Path 16121",
    d: "M304.121,185.83s9.416,5.419,11.326,11.793c1.158,3.868,9.937,53.357,11.326,63.111s-1.544,16.989-5.7,20.226-16.779,7.546-16.779,7.546l-17.713,5.751-5.087-12.951,16.867-24.236L296.738,240.7Z",
    transform: "translate(-157.757 -93.739)",
    fill: "#0090ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16122",
    "data-name": "Path 16122",
    d: "M233.757,170.794l-7.072-4.064s-6.442,7.532-15.227,6.611a22.149,22.149,0,0,1-14-7.62l-26.2,5.331h0c-1.754.352-4.958,1.463-8.027,5.846-3.421,4.884-19.644,26.553-19.644,26.553H132.26a8.42,8.42,0,0,0-7.451,4.5c-1.937,3.691-4.26,8.622-4.064,10.668.386,3.461-.284,12.951,4.356,15.911,1.47.942,6.726,3.759,10.838,3.57,6.022-.285,13.019-3.421,17.049-6.239,3.387-2.391,11.346-10.642,14.4-13.859v.068l1.964,68.72,68.686-1.951,14.225-105.481S234.448,170.794,233.757,170.794Z",
    transform: "translate(-105.893 -87.251)",
    fill: "#0090ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16123",
    "data-name": "Path 16123",
    d: "M189.212,200.4c.095,0,.278,8.515.4,19.021s.149,19.027.047,19.027-.278-8.515-.4-19.021S189.117,200.4,189.212,200.4Z",
    transform: "translate(-127.967 -98.44)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16124",
    "data-name": "Path 16124",
    d: "M311.691,282.41s-.583.095-1.619.291a20.045,20.045,0,0,0-4.254,1.355,27.725,27.725,0,0,0-5.663,3.421A49.324,49.324,0,0,0,294.187,293c-1.964,2.12-3.753,4.213-5.419,6.1a66.127,66.127,0,0,1-4.681,4.742,34.255,34.255,0,0,1-3.516,2.818c-.433.3-.793.508-1.03.677a1.736,1.736,0,0,1-.373.2,2.127,2.127,0,0,1,.332-.264c.224-.169.569-.393.989-.718a38,38,0,0,0,3.427-2.886c1.389-1.287,2.94-2.926,4.606-4.8s3.455-3.976,5.419-6.1a48.3,48.3,0,0,1,6.029-5.534,26.947,26.947,0,0,1,5.758-3.387,18.58,18.58,0,0,1,4.328-1.26c.528-.1.942-.1,1.219-.135A1.693,1.693,0,0,1,311.691,282.41Z",
    transform: "translate(-157.009 -124.898)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16125",
    "data-name": "Path 16125",
    d: "M321.947,275.537c0,.061-1.043.21-2.71.677a24.812,24.812,0,0,0-11.251,6.7c-1.179,1.226-1.809,2.08-1.856,2.032a3.053,3.053,0,0,1,.393-.63,15.47,15.47,0,0,1,1.28-1.578,22.529,22.529,0,0,1,11.366-6.774,17.96,17.96,0,0,1,2-.373,2.818,2.818,0,0,1,.779-.054Z",
    transform: "translate(-165.707 -122.679)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23502",
    "data-name": "Group 23502",
    transform: "translate(28.399 116.869)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16126",
    "data-name": "Path 16126",
    d: "M140.75,246.335c3.637.989,8-4.24,11.305-7.512,1.714-1.707,3.5-3.522,4.139-5.859a9.307,9.307,0,0,0-.576-5.859,21.384,21.384,0,0,0-2.418-4.694c.3,2.825,1,7.146.054,10.7-.793,2.96-2.669,5.311-4.66,7.546-2.1,2.364-4.593,4.843-7.844,5.683",
    transform: "translate(-140.75 -222.41)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16127",
    "data-name": "Path 16127",
    d: "M162.1,243.254c-.068,0,.352-1.2.677-3.17a23.48,23.48,0,0,0,.332-3.488,25.739,25.739,0,0,0-.284-4.274,26.262,26.262,0,0,0-1.043-4.159,23.982,23.982,0,0,0-1.4-3.218c-.928-1.775-1.693-2.764-1.639-2.8a3.734,3.734,0,0,1,.562.677,8.239,8.239,0,0,1,.589.84c.217.339.474.718.711,1.165a22.139,22.139,0,0,1,1.477,3.224,24.2,24.2,0,0,1,1.084,4.213,23.794,23.794,0,0,1,.264,4.342,20.73,20.73,0,0,1-.413,3.529c-.081.5-.21.935-.312,1.355a9.854,9.854,0,0,1-.3.982,4.45,4.45,0,0,1-.312.786Z",
    transform: "translate(-118.157 -105.454)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16128",
    "data-name": "Path 16128",
    d: "M236.769,169.64c.047.088-.759.555-1.6,1.314a18.75,18.75,0,0,1-1.49,1.436A5.114,5.114,0,0,1,236.769,169.64Z",
    transform: "translate(-142.333 -88.516)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16129",
    "data-name": "Path 16129",
    d: "M247.815,175.77c.075.075-.616.813-1.172,1.91s-.765,2.086-.867,2.032a3.807,3.807,0,0,1,.555-2.229A3.847,3.847,0,0,1,247.815,175.77Z",
    transform: "translate(-146.233 -90.494)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16130",
    "data-name": "Path 16130",
    d: "M266.163,180.172a11.182,11.182,0,0,1-.786-2.032,10.3,10.3,0,0,1-.677-2.08,5.256,5.256,0,0,1,1.03,1.964A5.068,5.068,0,0,1,266.163,180.172Z",
    transform: "translate(-152.34 -90.587)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16131",
    "data-name": "Path 16131",
    d: "M277.165,174.446c-.108,0-.373-1.172-1.152-2.439s-1.7-2.066-1.626-2.147a5.986,5.986,0,0,1,2.777,4.586Z",
    transform: "translate(-155.465 -88.587)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16132",
    "data-name": "Path 16132",
    d: "M309.228,209.49c.1,0-1.063,9.4-2.594,20.965s-2.852,20.931-2.947,20.917,1.063-9.4,2.594-20.965S309.134,209.476,309.228,209.49Z",
    transform: "translate(-164.917 -101.373)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16133",
    "data-name": "Path 16133",
    d: "M152.958,231.93a5.845,5.845,0,0,1,0,.969,7.451,7.451,0,0,1-.142,1.131c-.041.224-.074.454-.122.677s-.122.5-.2.772a20.815,20.815,0,0,1-1.355,3.692,25.646,25.646,0,0,1-2.527,4.1,21.743,21.743,0,0,1-3.387,3.455,14.679,14.679,0,0,1-3.387,2.032c-.264.1-.508.217-.745.3l-.677.19-.6.163c-.183.041-.359.047-.515.075a6.028,6.028,0,0,1-.969.074,17.476,17.476,0,0,0,3.387-1.036,15.357,15.357,0,0,0,3.265-2.032,22.611,22.611,0,0,0,3.278-3.387,26.261,26.261,0,0,0,2.506-4.024,22.541,22.541,0,0,0,1.409-3.617,34.952,34.952,0,0,0,.772-3.536Z",
    transform: "translate(-111.573 -108.613)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23503",
    "data-name": "Group 23503",
    transform: "translate(62.112 149.409)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16134",
    "data-name": "Path 16134",
    d: "M270.511,322.912c2.913-1.409,3.577-5.182,3.875-8.406q1.3-14.15,2.608-28.321c.413-4.437.61-9.483-2.52-12.68-2.859-2.9-7.4-3.069-11.475-3.055-25.131.068-47.328.806-72.479.874l1.28,43.968Z",
    transform: "translate(-190.52 -270.449)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16135",
    "data-name": "Path 16135",
    d: "M174.548,279.941l2.676,50.993a3.726,3.726,0,0,0,3.739,3.509l81.231.142a3.732,3.732,0,0,0,3.739-3.522l3.1-50.126c.108-2.086-1.355-4.857-3.482-4.9H178.361a3.719,3.719,0,0,0-3.814,3.9Z",
    transform: "translate(-123.253 -122.843)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16136",
    "data-name": "Path 16136",
    d: "M174.544,279.872v-.19a3.035,3.035,0,0,1,0-.569,3.685,3.685,0,0,1,.962-1.985,3.78,3.78,0,0,1,1.355-.928,4.8,4.8,0,0,1,1.964-.271h4.938l31.471-.054,46.678-.047h3.319a2.893,2.893,0,0,1,1.673.427,4.172,4.172,0,0,1,1.24,1.219,5.839,5.839,0,0,1,1.023,3.292c-.068,1.131-.135,2.276-.2,3.428q-.427,6.882-.867,14.042c-.583,9.544-1.192,19.42-1.822,29.54l-.115,1.9c-.054.63-.041,1.24-.156,1.9a3.9,3.9,0,0,1-2.452,2.879,4.607,4.607,0,0,1-1.9.251H241.475l-27.569-.061-24.948-.061h-7.133c-.467,0-.928,0-1.416-.047a3.868,3.868,0,0,1-2.432-1.355,3.922,3.922,0,0,1-.908-2.567c-.047-.887-.088-1.761-.135-2.628-.088-1.741-.176-3.434-.264-5.094-.677-13.27-1.212-24.006-1.592-31.43-.176-3.705-.318-6.584-.413-8.548-.041-.975-.075-1.714-.1-2.222a5.3,5.3,0,0,1,0-.759,7.057,7.057,0,0,0,.061.759c.061.5.075,1.246.129,2.215.115,1.964.278,4.843.488,8.548.4,7.451.982,18.16,1.7,31.423.088,1.66.183,3.353.278,5.094.041.867.088,1.741.135,2.628a3.658,3.658,0,0,0,.853,2.4,3.577,3.577,0,0,0,2.262,1.246,11.438,11.438,0,0,0,1.355.041h32.107l27.569.041h20.172a4.342,4.342,0,0,0,1.781-.23,3.536,3.536,0,0,0,2.229-2.615c.1-.576.1-1.24.149-1.856l.115-1.9c.63-10.12,1.24-20,1.836-29.534q.44-7.167.867-14.049c.074-1.145.142-2.283.21-3.421a5.514,5.514,0,0,0-.962-3.089,3.008,3.008,0,0,0-2.649-1.5h-49.99l-31.471-.047h-4.938a4.742,4.742,0,0,0-1.931.251,3.7,3.7,0,0,0-2.317,2.838,6.88,6.88,0,0,0-.061.691Z",
    transform: "translate(-123.249 -122.774)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_882",
    "data-name": "Ellipse 882",
    cx: 4.782,
    cy: 4.782,
    r: 4.782,
    transform: "translate(94.355 177.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16137",
    "data-name": "Path 16137",
    d: "M247.591,316.167a7.75,7.75,0,0,0-.217-1.152,4.742,4.742,0,0,0-1.748-2.554,4.558,4.558,0,0,0-1.964-.853,4.7,4.7,0,0,0-2.425.217,4.552,4.552,0,0,0-2.14,1.612,4.626,4.626,0,0,0,4.565,7.282,4.559,4.559,0,0,0,1.964-.853,4.742,4.742,0,0,0,1.748-2.547c.2-.725.183-1.158.217-1.152a.873.873,0,0,1,0,.3,3.469,3.469,0,0,1-.1.881,4.789,4.789,0,0,1-1.727,2.71,4.928,4.928,0,1,1-2.066-8.745,4.8,4.8,0,0,1,2.032.942,4.742,4.742,0,0,1,1.727,2.71,3.387,3.387,0,0,1,.1.874.934.934,0,0,1,.034.325Z",
    transform: "translate(-143.671 -134.196)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16138",
    "data-name": "Path 16138",
    d: "M178.58,290.13c.095,0,.5,8.569.894,19.143s.637,19.149.542,19.149-.481-8.576-.894-19.143S178.485,290.137,178.58,290.13Z",
    transform: "translate(-124.549 -127.389)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16139",
    "data-name": "Path 16139",
    d: "M140.618,176.092c-.481-.406,1.605-8.413,1.605-8.413s-5.514-8.989-5.656-11.888,2.174-8.847,2.174-8.847l15.8-4.064s5.08,9.429,6.1,12.762-1.741,14.645-1.741,14.645l-2.71,5.805S148.143,182.472,140.618,176.092Z",
    transform: "translate(-110.999 -79.883)",
    fill: "#936760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16140",
    "data-name": "Path 16140",
    d: "M135.221,148.295a35.86,35.86,0,0,1-1.666-3.516c-1-2.371-2.229-4.7,0-6.029a2.913,2.913,0,0,1,2.384-.373s-.339-2.032.854-2.75a2.588,2.588,0,0,1,2.344-.2s-.379-2.818,1.355-4.01a4.159,4.159,0,0,1,4.376-.129s-1.355-12.335-1.477-12.985c-.434-2.4.454-4.525,2.838-3.929.874.217,1.355,1.138,2.384,5.155s2.676,10.872,2.676,10.872,2.777,4.823,4.064,7.451,3.908,8.576,4.125,10.161c.555,4.064-1.836,9.483-1.836,9.483l-16.8.975Z",
    transform: "translate(-109.626 -70.652)",
    fill: "#936760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16141",
    "data-name": "Path 16141",
    d: "M136.879,150.64a14.7,14.7,0,0,1,1.3,1.815l1.355,2.032a9.191,9.191,0,0,1,.725,1.26,2.574,2.574,0,0,1,.2,1.605,1.626,1.626,0,0,1-1.063,1.246,2.093,2.093,0,0,1-1.5-.19,6.9,6.9,0,0,1-1.124-.677c-.325-.237-.63-.467-.9-.677-.549-.427-.969-.793-1.253-1.057s-.434-.413-.42-.434.677.494,1.822,1.287a14.012,14.012,0,0,0,2.032,1.273,1.8,1.8,0,0,0,1.267.156,1.267,1.267,0,0,0,.82-1,2.235,2.235,0,0,0-.169-1.355,9.228,9.228,0,0,0-.677-1.219l-1.267-2.032A13.927,13.927,0,0,1,136.879,150.64Z",
    transform: "translate(-110.234 -82.386)",
    fill: "#6f4c47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16142",
    "data-name": "Path 16142",
    d: "M158.463,150.394a5.832,5.832,0,0,1,.176-2.642,5.643,5.643,0,0,1,1.05-2.432c.095.047-.373,1.124-.677,2.513A19.43,19.43,0,0,1,158.463,150.394Z",
    transform: "translate(-118.041 -80.67)",
    fill: "#6f4c47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16143",
    "data-name": "Path 16143",
    d: "M160.368,156.551a11.15,11.15,0,0,0-5.622-2.933,21.121,21.121,0,0,0-6.4-.244c-1.707.156-3.665.6-4.437,2.127s.163,3.6,1.673,4.5a8.567,8.567,0,0,0,5.155.786,21.927,21.927,0,0,1,5.277-.217",
    transform: "translate(-113.28 -83.224)",
    fill: "#936760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16144",
    "data-name": "Path 16144",
    d: "M155.912,160.517a9.849,9.849,0,0,0-1.355,0,35.784,35.784,0,0,0-3.6.339,15.039,15.039,0,0,1-2.527.108,6.937,6.937,0,0,1-2.831-.711,4.382,4.382,0,0,1-2.1-2.445,3.387,3.387,0,0,1-.122-1.748,3.055,3.055,0,0,1,.928-1.558,6.1,6.1,0,0,1,3.231-1.253,27.735,27.735,0,0,1,3.19-.19,16.169,16.169,0,0,1,5.344.806,10.648,10.648,0,0,1,3.2,1.734,6.871,6.871,0,0,1,.738.677,1.307,1.307,0,0,1,.224.264s-.352-.318-1.043-.82a11.318,11.318,0,0,0-3.2-1.605,16.352,16.352,0,0,0-5.256-.718,28.452,28.452,0,0,0-3.15.21,5.737,5.737,0,0,0-3.041,1.172,2.655,2.655,0,0,0-.82,1.355,2.994,2.994,0,0,0,.1,1.565,4.064,4.064,0,0,0,1.931,2.269,6.6,6.6,0,0,0,2.71.677,15.581,15.581,0,0,0,2.479-.061,28.211,28.211,0,0,1,3.631-.237,9.6,9.6,0,0,1,.982.095A1.213,1.213,0,0,1,155.912,160.517Z",
    transform: "translate(-113.179 -83.166)",
    fill: "#6f4c47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16145",
    "data-name": "Path 16145",
    d: "M138.34,150.488c1.768,2.71,3.326,5.636,4.816,8.481a5.209,5.209,0,0,0,1.693,2.195c.637.393,2.215-.318,2.926-.562l-4.857-11.041",
    transform: "translate(-111.573 -82.038)",
    fill: "#936760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16146",
    "data-name": "Path 16146",
    d: "M142.919,149.56a4.952,4.952,0,0,1,.434.82l1.07,2.317c.9,1.964,2.134,4.742,3.509,7.837l.081.169-.183.068c-.522.183-1.084.42-1.693.576a3.8,3.8,0,0,1-.745.108,1.313,1.313,0,0,1-.393-.041.928.928,0,0,1-.366-.183,3.774,3.774,0,0,1-.982-1.043c-.494-.786-.847-1.572-1.246-2.3-.759-1.47-1.456-2.784-2.066-3.881s-1.111-1.971-1.47-2.574a7.83,7.83,0,0,1-.528-.948,5.42,5.42,0,0,1,.644.881c.393.576.942,1.436,1.572,2.52s1.355,2.384,2.14,3.847c.4.725.772,1.524,1.246,2.262a3.584,3.584,0,0,0,.887.948,1.45,1.45,0,0,0,1.219.054c.576-.142,1.124-.373,1.666-.562l-.122.257c-1.355-3.123-2.56-5.893-3.387-7.885l-.975-2.357a5.364,5.364,0,0,1-.312-.894Z",
    transform: "translate(-111.573 -82.038)",
    fill: "#6f4c47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16147",
    "data-name": "Path 16147",
    d: "M143.17,143.691q2.337,5.873,4.681,11.739a7.979,7.979,0,0,0,1.26,2.357,2.71,2.71,0,0,0,2.357,1.023,2.76,2.76,0,0,0,2.08-2.709,8.717,8.717,0,0,0-.881-3.563,74.2,74.2,0,0,1-3.353-10.987",
    transform: "translate(-113.132 -79.454)",
    fill: "#936760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16148",
    "data-name": "Path 16148",
    d: "M149.327,141.56a2.528,2.528,0,0,1,.115.359c.075.271.163.616.278,1.036.244.9.6,2.2,1.091,3.793s1.131,3.468,1.937,5.514a11.516,11.516,0,0,1,.982,3.387,3.712,3.712,0,0,1-.359,1.87,2.75,2.75,0,0,1-1.4,1.355,2.357,2.357,0,0,1-1.971-.163,3.7,3.7,0,0,1-1.355-1.3,20.951,20.951,0,0,1-1.416-3.19c-.8-2.032-1.517-3.888-2.134-5.453s-1.057-2.777-1.409-3.692l-.373-1.009a1.592,1.592,0,0,1-.1-.366,1.753,1.753,0,0,1,.169.339l.434.982c.373.908.887,2.147,1.511,3.651s1.355,3.387,2.208,5.419a20.861,20.861,0,0,0,1.4,3.116,3.326,3.326,0,0,0,1.253,1.179,2.032,2.032,0,0,0,1.68.142,2.391,2.391,0,0,0,1.219-1.2,3.339,3.339,0,0,0,.325-1.693,11.441,11.441,0,0,0-.942-3.258c-.793-2.032-1.409-3.963-1.87-5.561s-.786-2.926-.989-3.834c-.095-.461-.169-.813-.21-1.057A1.2,1.2,0,0,1,149.327,141.56Z",
    transform: "translate(-113.144 -79.457)",
    fill: "#6f4c47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16149",
    "data-name": "Path 16149",
    d: "M138.391,184.333s-10.716,31.606-11.143,33.151,2.12,12.836,6.774,15.512,13.683-8.46,14.807-12.552,0-11,0-11l7.228-27.224",
    transform: "translate(-107.98 -92.575)",
    fill: "#936760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16150",
    "data-name": "Path 16150",
    d: "M156.861,176a2.032,2.032,0,0,1-1.009-.129,5.6,5.6,0,0,1-2.127-1.226,5.52,5.52,0,0,1-1.409-2.032,1.978,1.978,0,0,1-.217-1,9.117,9.117,0,0,0,1.863,2.757A8.955,8.955,0,0,0,156.861,176Z",
    transform: "translate(-116.012 -89.155)",
    fill: "#6f4c47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-15",
    transform: "translate(49.707 401.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16151",
    "data-name": "Path 16151",
    d: "M440.259,404.218c0,.149-87.425.268-195.25.268s-195.269-.119-195.269-.268,87.415-.258,195.269-.258S440.259,404.079,440.259,404.218Z",
    transform: "translate(-49.74 -403.96)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-15",
    transform: "translate(-81.261 90.02)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8827",
    "data-name": "Rectangle 8827",
    width: 227.61,
    height: 68.008,
    rx: 5.29,
    transform: "translate(15.778 17.093)",
    fill: "#0090ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16152",
    "data-name": "Path 16152",
    d: "M288.392,137.826H88.36c-5.733-.054-10.35-4.154-10.36-9.2V78.788c.01-5.076,4.684-9.189,10.453-9.2h199.94c5.769.009,10.443,4.122,10.453,9.2v49.84c-.01,5.076-4.684,9.189-10.453,9.2ZM88.36,71.221c-4.709.053-8.5,3.423-8.507,7.567v49.84c0,4.179,3.85,7.567,8.6,7.567h199.94c4.749,0,8.6-3.388,8.6-7.567V78.788c-.01-4.176-3.854-7.558-8.6-7.567Z",
    transform: "translate(-43.84 -53.129)",
    fill: "#0090ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16162",
    "data-name": "Path 16162",
    d: "M195.836,114a18.394,18.394,0,0,1-3.892-4.273,17.441,17.441,0,0,1-3.114-4.746,18.7,18.7,0,0,1,3.911,4.273A17.091,17.091,0,0,1,195.836,114Z",
    transform: "translate(50.737 -30.802)",
    fill: "#0090ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16163",
    "data-name": "Path 16163",
    d: "M201.951,83.668a44.367,44.367,0,0,1-6.135-6.719,45.676,45.676,0,0,1-5.356-7.209,44.368,44.368,0,0,1,6.135,6.719A44.317,44.317,0,0,1,201.951,83.668Z",
    transform: "translate(52.128 -53.034)",
    fill: "#0090ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16164",
    "data-name": "Path 16164",
    d: "M201.47,111.254c-.278.179-3.058-3.262-6.1-7.861-1.538-2.251-2.891-4.306-3.836-5.806a11.785,11.785,0,0,1-1.446-2.5c.278-.163,3.058,3.36,6.1,7.861,1.538,2.251,2.891,4.306,3.855,5.806a11.109,11.109,0,0,1,1.427,2.5Z",
    transform: "translate(51.813 -37.044)",
    fill: "#0090ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16165",
    "data-name": "Path 16165",
    d: "M202.322,102.987c-.278.179-3.243-3.621-6.524-8.464-1.649-2.43-3.114-4.632-4.151-6.246A13.969,13.969,0,0,1,190.09,85.6c.278-.163,3.243,3.637,6.542,8.481,1.649,2.414,3.1,4.632,4.133,6.23A13.331,13.331,0,0,1,202.322,102.987Z",
    transform: "translate(51.813 -43.031)",
    fill: "#0090ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16166",
    "data-name": "Path 16166",
    d: "M202.346,94.4c-.278.179-3.262-3.653-6.561-8.513-1.668-2.43-3.132-4.664-4.17-6.279a13.384,13.384,0,0,1-1.575-2.691c.278-.163,3.262,3.653,6.561,8.53,1.668,2.43,3.132,4.648,4.17,6.279A12.566,12.566,0,0,1,202.346,94.4Z",
    transform: "translate(51.77 -48.513)",
    fill: "#0090ff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Coming_Soon",
    "data-name": "Coming Soon",
    transform: "translate(129.778 59.094)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -84.36,
    y: 0
  }, "Coming Soon")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup23504);
export default __webpack_public_path__ + "static/media/Group 23504.6097840de145d8e7f9407b74cb126b85.svg";
export { ForwardRef as ReactComponent };